import { apiUrls, filterRoles } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setValue: Function
  setShowOverlay: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.users, props.id).then((data) => {
        props.reset(data)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      const allRoles = filterRoles

      props.setValue('role', allRoles[0] ?? null)

      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
